import { VDialog, VBtn, VLayout, VAlert, VCol, VRow, VContainer, VProgressCircular, VSwitch, VTextField, VIcon, VTooltip, VTextarea, VSnackbar, VCard } from 'vuetify/lib';

//
//
//
//
//
//
//
//
//
//
//
var script$k = {
  components: {
    VDialog: VDialog
  },

  props: {
    fullscreen: {
      type: Boolean,
      required: false,
      default: false
    },
    contentClass: {
      type: String,
      default: ''
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$k = script$k;
/* template */

var __vue_render__$h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "fullscreen": _vm.fullscreen,
      "value": true,
      "content-class": "VcModalWrapper " + _vm.contentClass
    },
    on: {
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
          return null;
        }

        return _vm.$emit('onCloseButtonClicked');
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.$emit('onEnterClicked');
      }],
      "click:outside": function ($event) {
        return _vm.$emit('onClickOutside');
      }
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$h = [];
/* style */

const __vue_inject_styles__$k = function (inject) {
  if (!inject) return;
  inject("data-v-f5aa52c8_0", {
    source: ".VcModalWrapper{position:relative;width:auto;background-color:var(--modal-bg-color);box-shadow:var(--modal-box-shadow)}@media screen and (min-width:960px){.VcModalWrapper{margin:0 24px;left:var(--modal-desktop-offset)}#app[dir=rtl] .VcModalWrapper{left:auto;right:var(--modal-desktop-offset)}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$k = undefined;
/* module identifier */

const __vue_module_identifier__$k = undefined;
/* functional template */

const __vue_is_functional_template__$k = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$k, __vue_script__$k, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, createInjector, undefined, undefined);

var script$j = {
  name: "VcIcon",
  render: function (createElement) {
    const props = {
      attrs: { ...this.$attrs
      }
    };
    return createElement('v-icon', props, this.$slots.default);
  }
};

/* script */
const __vue_script__$j = script$j;
/* template */

/* style */

const __vue_inject_styles__$j = undefined;
/* scoped */

const __vue_scope_id__$j = undefined;
/* module identifier */

const __vue_module_identifier__$j = undefined;
/* functional template */

const __vue_is_functional_template__$j = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$j = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__$j, __vue_script__$j, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$i = {
  components: {
    VBtn: VBtn
  },

  name: "VcButton",

  props: {
    label: {
      type: String,
      required: false
    },
    customClass: {
      type: String,
      default: ''
    },
    plain: {
      type: Boolean,
      default: false
    },
    xSmall: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    xLarge: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      required: false,
      default: 'secondary',
      validator: type => {
        return ['secondary', 'white'].indexOf(type) > -1;
      }
    },
    icon: {
      type: Boolean,
      default: false
    },
    fab: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      required: false
    },
    dataQa: {
      type: String,
      default: 'vc-btn'
    }
  }
};

/* script */
const __vue_script__$i = script$i;
/* template */

var __vue_render__$g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-btn', {
    staticClass: "VcButton",
    attrs: {
      "color": _vm.color,
      "icon": _vm.icon,
      "fab": _vm.fab,
      "plain": _vm.plain,
      "x-small": _vm.xSmall,
      "small": _vm.small,
      "large": _vm.large,
      "x-large": _vm.xLarge,
      "elevation": 0,
      "width": _vm.width,
      "min-width": "0",
      "loading": _vm.loading,
      "data-qa": _vm.dataQa
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_vm._t("prepend"), _vm._v("\n  " + _vm._s(_vm.label || _vm.$slots.default && _vm.$slots.default[0].text || '') + "\n  "), _vm._t("append")], 2);
};

var __vue_staticRenderFns__$g = [];
/* style */

const __vue_inject_styles__$i = function (inject) {
  if (!inject) return;
  inject("data-v-b7472c46_0", {
    source: ".VcButton[data-v-b7472c46]{letter-spacing:.003em}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$i = "data-v-b7472c46";
/* module identifier */

const __vue_module_identifier__$i = undefined;
/* functional template */

const __vue_is_functional_template__$i = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$i, __vue_script__$i, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, createInjector, undefined, undefined);

var script$h = {
  name: 'VcModalContainer',
  components: {
    VcButton: __vue_component__$i,
    VcModalWrapper: __vue_component__$k,
    VcIcon: __vue_component__$j,
    VLayout: VLayout
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    size: {
      type: String,
      default: 'lg',
      // required
      validator: prop => ['sm', 'md', 'lg', 'responsive'].includes(prop)
    },
    showHeaderDivider: {
      type: Boolean,
      default: false
    },
    showFooterDivider: {
      type: Boolean,
      default: true
    },
    showCloseButton: {
      type: Boolean,
      default: false
    },
    flavor: {
      type: String,
      required: false,
      validator: prop => ['', 'confirm', 'notice', 'input', 'prominent'].includes(prop)
    }
  },
  computed: {
    displayCloseButton() {
      if (this.flavor === 'input' && !this.$vuetify.breakpoint.mdAndUp) return false;
      return this.showCloseButton;
    }

  }
};

/* script */
const __vue_script__$h = script$h;
/* template */

var __vue_render__$f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.showDialog ? _c('VcModalWrapper', {
    attrs: {
      "contentClass": _vm.size + " VcModalContainer " + (_vm.flavor ? _vm.flavor : 'unflavored')
    },
    on: {
      "click-outside": function ($event) {
        return _vm.$emit('onClickOutside');
      },
      "onCloseButtonClicked": function ($event) {
        return _vm.$emit('onCloseButtonClicked');
      },
      "enterPressed": function ($event) {
        return _vm.$emit('onEnterClicked');
      }
    }
  }, [[_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('header', {
    class: {
      'showDivider': _vm.showHeaderDivider
    }
  }, [_vm._t("header"), _vm._v(" "), _vm.displayCloseButton ? _c('VcButton', {
    staticClass: "VcModalCloseButton",
    attrs: {
      "icon": "",
      "fab": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onCloseButtonClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('svg', {
          attrs: {
            "width": "14",
            "height": "14",
            "viewBox": "0 0 14 14",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('path', {
          attrs: {
            "d": "M12.3047 13.0138L13.0119 12.3066C13.1093 12.2091 13.1093 12.0507 13.0119 11.9532L8.05931 7.00064L13.0065 2.05349C13.104 1.95599 13.104 1.79754 13.0065 1.70007L12.2993 0.992855C12.2018 0.895382 12.0434 0.895382 11.9459 0.992855L6.99867 5.94L2.04911 0.99012C1.9516 0.892616 1.79316 0.892616 1.69568 0.99012L0.988167 1.6973C0.890663 1.79481 0.890663 1.95325 0.988167 2.05076L5.93803 7.00064L0.993702 11.9447C0.896198 12.0422 0.896198 12.2006 0.993702 12.2981L1.70088 13.0053C1.79839 13.1028 1.95683 13.1028 2.05434 13.0053L6.99867 8.06127L11.9512 13.0138C12.0487 13.1113 12.2072 13.1113 12.3047 13.0138Z",
            "fill": "black",
            "fill-opacity": "0.4"
          }
        })])];
      },
      proxy: true
    }], null, false, 4251314713)
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "VcModalContainerContent"
  }, [_vm._t("content")], 2), _vm._v(" "), _c('footer', {
    class: {
      'showDivider': _vm.showFooterDivider
    }
  }, [_vm._t("footer")], 2)])]], 2) : _vm._e();
};

var __vue_staticRenderFns__$f = [];
/* style */

const __vue_inject_styles__$h = function (inject) {
  if (!inject) return;
  inject("data-v-bdb325aa_0", {
    source: ".VcModalContainer{overflow-y:hidden;height:auto;min-height:100px;min-width:300px;display:flex}.VcModalContainer.sm{width:var(--modal-width-small)}.VcModalContainer.md{width:var(--modal-width-medium)}.VcModalContainer.lg{width:var(--modal-width-large)}.VcModalContainer.responsive{margin:0}.VcModalContainer .VcModalContainerContent,.VcModalContainer footer,.VcModalContainer header{flex-shrink:0}.VcModalContainer header{display:flex;justify-content:space-between}.VcModalContainer header .VcModalCloseButton{position:absolute;right:5px;top:var(--size-value2)}.VcModalContainer header .VcModalCloseButton .VcIcon{font-size:22px}.VcModalContainer header.showDivider{border-bottom:1px solid rgba(0,0,0,.12)}.VcModalContainer .VcModalContainerContent{overflow-y:auto;height:calc(100% - 138px);line-height:var(--size-value6);flex-grow:1;font-size:var(--font-size-small);padding:0 var(--size-value6) var(--size-value6)}.VcModalContainer footer{padding:var(--size-value3) var(--size-value4) var(--size-value3);text-align:right}#app[dir=rtl] .VcModalContainer footer{text-align:left}.VcModalContainer footer.showDivider{border-top:1px solid rgba(0,0,0,.12)}@media screen and (min-width:960px){.VcModalContainer footer{padding:var(--size-value3) var(--size-value6) var(--size-value3)}}.VcModalContainer.notice header,.VcModalContainer.prominent header{font-weight:var(--font-weight-xl);font-size:var(--font-size-medium2);padding-bottom:0;padding-top:var(--size-value10)}.VcModalContainer.notice .VcModalContainerContent,.VcModalContainer.prominent .VcModalContainerContent{padding:0;min-height:168px;height:calc(100% - 497px)}@media screen and (min-width:960px){.VcModalContainer.notice .VcModalContainerContent,.VcModalContainer.prominent .VcModalContainerContent{margin-bottom:var(--size-value2)}}.VcModalContainer.notice footer,.VcModalContainer.prominent footer{padding-top:var(--size-value3);padding-bottom:0}.VcModalContainer.notice.responsive .VcModalContainerContent,.VcModalContainer.notice.sm .VcModalContainerContent,.VcModalContainer.prominent.responsive .VcModalContainerContent,.VcModalContainer.prominent.sm .VcModalContainerContent{margin-left:var(--size-value6);padding-right:var(--size-value6)}.VcModalContainer.notice.md .VcModalContainerContent,.VcModalContainer.prominent.md .VcModalContainerContent{margin-left:var(--size-value10);padding-right:var(--size-value10)}.VcModalContainer.notice.lg header,.VcModalContainer.prominent.lg header{height:initial}.VcModalContainer.notice.lg .VcModalContainerContent,.VcModalContainer.prominent.lg .VcModalContainerContent{min-height:0;margin-left:var(--size-value16);padding-right:var(--size-value16)}.VcModalContainer.prominent .VcModalContainerContent{margin-bottom:var(--size-value6)}.VcModalContainer.input.responsive{height:100%;border-bottom-left-radius:0;border-bottom-right-radius:0}.VcModalContainer.input .VcModalContainerContent{height:auto;padding:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$h = undefined;
/* module identifier */

const __vue_module_identifier__$h = undefined;
/* functional template */

const __vue_is_functional_template__$h = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$h, __vue_script__$h, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, createInjector, undefined, undefined);

var script$g = {
  name: "VcLayout",
  render: function (createElement) {
    // `<v-layout><slot></slot></v-layout>`
    const props = {
      attrs: { ...this.$attrs
      }
    };
    return createElement('v-layout', props, this.$slots.default);
  }
};

/* script */
const __vue_script__$g = script$g;
/* template */

/* style */

const __vue_inject_styles__$g = undefined;
/* scoped */

const __vue_scope_id__$g = "data-v-42241056";
/* module identifier */

const __vue_module_identifier__$g = undefined;
/* functional template */

const __vue_is_functional_template__$g = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__$g, __vue_script__$g, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, undefined, undefined, undefined);

var script$f = {
  name: "VcModalFooter",
  components: {
    VcLayout: __vue_component__$g,
    VcButton: __vue_component__$i
  },
  props: {
    direction: {
      type: String,
      default: 'horizontal',
      validator: prop => ['horizontal', 'vertical'].includes(prop)
    },
    buttons: {
      type: Array,
      default: () => [{
        label: 'ok',
        event: 'onOkClicked',
        color: 'primary'
      }, {
        label: 'cancel',
        event: 'onCancelClicked',
        color: 'secondary'
      }],
      validator: prop => prop.every(e => e.label && e.event)
    }
  }
};

/* script */
const __vue_script__$f = script$f;
/* template */

var __vue_render__$e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    class: "VcModalFooter " + _vm.direction,
    attrs: {
      "column": _vm.direction === 'vertical',
      "justify-end": _vm.$vuetify.breakpoint.mdAndUp && _vm.direction === 'horizontal',
      "align-center": !_vm.$vuetify.breakpoint.mdAndUp || _vm.direction === 'vertical'
    }
  }, _vm._l(_vm.buttons, function (button) {
    return _c('VcButton', {
      key: button.event,
      staticClass: "VcFooterButton",
      attrs: {
        "color": button.color,
        "label": button.label,
        "large": !_vm.$vuetify.breakpoint.mdAndUp
      },
      on: {
        "click": function ($event) {
          return _vm.$emit(button.event);
        }
      }
    });
  }), 1);
};

var __vue_staticRenderFns__$e = [];
/* style */

const __vue_inject_styles__$f = function (inject) {
  if (!inject) return;
  inject("data-v-4900acdc_0", {
    source: ".VcModalFooter.vertical .VcFooterButton[data-v-4900acdc]{width:100%;margin-bottom:var(--size-value2)}.VcModalFooter.vertical .VcFooterButton[data-v-4900acdc]:last-of-type{margin-bottom:0}@media screen and (min-width:960px){.VcModalFooter.vertical .VcFooterButton[data-v-4900acdc]{width:auto}}.VcModalFooter.horizontal .VcFooterButton[data-v-4900acdc]{flex-basis:0;flex-grow:1}.VcModalFooter.horizontal .VcFooterButton[data-v-4900acdc]:first-of-type{margin-left:0}.VcModalFooter.horizontal .VcFooterButton[data-v-4900acdc]:last-of-type{margin-right:0}@media screen and (min-width:960px){.VcModalFooter.horizontal .VcFooterButton[data-v-4900acdc]{flex-basis:auto;flex-grow:0}}.VcModalFooter .VcFooterButton[data-v-4900acdc]{margin-left:var(--size-value1);margin-right:var(--size-value1)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$f = "data-v-4900acdc";
/* module identifier */

const __vue_module_identifier__$f = undefined;
/* functional template */

const __vue_is_functional_template__$f = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$f, __vue_script__$f, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, createInjector, undefined, undefined);

var script$e = {
  name: "VcModalHeader",
  components: {
    VcLayout: __vue_component__$g,
    VcIcon: __vue_component__$j,
    VcButton: __vue_component__$i
  },
  props: {
    topTitle: {
      Type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    image: {
      type: String,
      required: false
    },
    flavor: {
      type: String,
      default: 'confirm',
      validator: prop => ['confirm', 'input'].includes(prop)
    }
  },
  computed: {
    isBackButtonDisplayed() {
      return this.flavor === 'input' && !this.$vuetify.breakpoint.mdAndUp;
    }

  }
};

/* script */
const __vue_script__$e = script$e;
/* template */

var __vue_render__$d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    class: "VcHeader " + _vm.flavor,
    attrs: {
      "align-center": ""
    }
  }, [_vm.isBackButtonDisplayed ? _c('VcButton', {
    staticClass: "VcHeaderButton",
    attrs: {
      "icon": "",
      "fab": "",
      "small": "",
      "width": 24
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onCloseButtonClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('svg', {
          attrs: {
            "width": "8",
            "height": "14",
            "viewBox": "0 0 8 14",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('path', {
          attrs: {
            "d": "M7.45226 13.8605L7.67324 13.6396C7.81969 13.4931 7.81969 13.2557 7.67324 13.1092L1.56409 7.00006L7.67324 0.890882C7.81969 0.744459 7.81969 0.507003 7.67324 0.360549L7.45226 0.139602C7.30584 -0.0068206 7.06841 -0.0068206 6.92196 0.139602L0.326637 6.73489C0.180183 6.88135 0.180183 7.11877 0.326637 7.26526L6.92196 13.8605C7.06841 14.007 7.30584 14.007 7.45226 13.8605Z",
            "fill": "black",
            "fill-opacity": "0.4"
          }
        })])];
      },
      proxy: true
    }], null, false, 3344096172)
  }) : _vm._e(), _vm._v(" "), _vm.icon ? _c('VcIcon', {
    staticClass: "VcHeaderIcon",
    attrs: {
      "color": "warning"
    }
  }, [_vm._v(_vm._s(_vm.icon))]) : _vm._e(), _vm._v(" "), _vm._t("headerImage", function () {
    return [_vm.image ? _c('img', {
      staticClass: "VcHeaderImage",
      attrs: {
        "src": _vm.image
      }
    }) : _vm._e()];
  }), _vm._v(" "), _c('VcLayout', {
    attrs: {
      "column": ""
    }
  }, [_vm.topTitle ? _c('div', {
    staticClass: "VcHeaderTopTitle"
  }, [_vm._v(_vm._s(_vm.topTitle))]) : _vm._e(), _vm._v(" "), _c('VcLayout', {
    attrs: {
      "justify-space-between": !_vm.$vuetify.breakpoint.mdAndUp
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm.subtitle ? _c('div', {
    staticClass: "VcHeaderSubtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()])], 1)], 2);
};

var __vue_staticRenderFns__$d = [];
/* style */

const __vue_inject_styles__$e = function (inject) {
  if (!inject) return;
  inject("data-v-407bef94_0", {
    source: ".VcHeader[data-v-407bef94]{font-size:var(--font-size-small2);padding:var(--size-value4) var(--size-value6) var(--size-value4);line-height:24px;font-weight:var(--font-weight-large2)}@media screen and (min-width:960px){.VcHeader[data-v-407bef94]{font-weight:var(--font-weight-large);font-size:var(--font-size-medium)}}.VcHeader .VcHeaderImage[data-v-407bef94]{width:32px;margin-right:var(--size-value3);padding:5px;border:1px solid rgba(0,0,0,.12);box-sizing:border-box;border-radius:6px}.VcHeader .VcHeaderTopTitle[data-v-407bef94]{font-size:11px;font-weight:var(--font-weight-medium);line-height:12px;color:rgba(0,0,0,.54)}.VcHeader .VcHeaderTitleWithPadding[data-v-407bef94]{padding-left:var(--size-value6)}.VcHeader .VcHeaderSubtitle[data-v-407bef94]{font-size:15px;font-weight:var(--font-weight-medium);color:rgba(0,0,0,.87);padding-left:var(--size-value2)}.VcHeader.confirm[data-v-407bef94]{font-size:var(--font-size-medium);font-weight:var(--font-weight-large2);padding-bottom:var(--size-value1);padding-top:var(--size-value6)}@media screen and (min-width:960px){.VcHeader.confirm[data-v-407bef94]{padding-bottom:var(--size-value1)}}.VcHeader.confirm .VcHeaderButton[data-v-407bef94],.VcHeader.input .VcHeaderButton[data-v-407bef94]{max-height:24px;margin-right:var(--size-value3)}.VcHeader.confirm .VcHeaderIcon[data-v-407bef94],.VcHeader.input .VcHeaderIcon[data-v-407bef94]{padding-right:var(--size-value3);font-size:var(--font-size-medium)}.VcHeader.input[data-v-407bef94]{transform:translateX(-8px)}@media screen and (min-width:960px){.VcHeader.input[data-v-407bef94]{transform:translateX(0);padding-bottom:var(--size-value3)}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$e = "data-v-407bef94";
/* module identifier */

const __vue_module_identifier__$e = undefined;
/* functional template */

const __vue_is_functional_template__$e = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, createInjector, undefined, undefined);

var script$d = {
  name: "VcConfirmModal",
  components: {
    VcModalHeader: __vue_component__$e,
    VcLayout: __vue_component__$g,
    VcModalFooter: __vue_component__$f,
    VcIcon: __vue_component__$j,
    VcModalContainer: __vue_component__$h
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    topTitle: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    headerImage: {
      type: String,
      required: false
    },
    headerIcon: {
      type: String,
      required: false
    },
    contentText: {
      type: String,
      required: false
    },
    size: {
      type: String,
      default: 'lg',
      // required
      validator: prop => ['sm', 'md', 'lg'].includes(prop)
    }
  }
};

/* script */
const __vue_script__$d = script$d;
/* template */

var __vue_render__$c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcModalContainer', {
    attrs: {
      "showCloseButton": "",
      "showDialog": _vm.showDialog,
      "size": _vm.$vuetify.breakpoint.mdAndUp ? _vm.size : 'responsive'
    },
    on: {
      "onCloseButtonClicked": function ($event) {
        return _vm.$emit('onCloseButtonClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_vm._t("header", function () {
          return [_c('VcModalHeader', {
            attrs: {
              "topTitle": _vm.topTitle,
              "title": _vm.title,
              "subtitle": _vm.subtitle,
              "icon": _vm.headerIcon,
              "image": _vm.headerImage,
              "flavor": "confirm"
            },
            on: {
              "onCloseButtonClicked": function ($event) {
                return _vm.$emit('onCloseButtonClicked');
              }
            }
          })];
        })];
      },
      proxy: true
    }, {
      key: "content",
      fn: function () {
        return [_vm._t("content", function () {
          return [_vm._v(" " + _vm._s(_vm.contentText) + " ")];
        })];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function () {
        return [_vm._t("footer", function () {
          return [_c('VcModalFooter', {
            attrs: {
              "direction": "horizontal",
              "buttons": [{
                label: "Cancel",
                event: "onCancelClicked",
                color: "white"
              }, {
                label: "Ok",
                event: "onOkClicked",
                color: "secondary"
              }]
            },
            on: {
              "onOkClicked": function ($event) {
                return _vm.$emit('onOkClicked');
              },
              "onCancelClicked": function ($event) {
                return _vm.$emit('onCancelClicked');
              }
            }
          })];
        })];
      },
      proxy: true
    }], null, true)
  });
};

var __vue_staticRenderFns__$c = [];
/* style */

const __vue_inject_styles__$d = undefined;
/* scoped */

const __vue_scope_id__$d = "data-v-716e5a70";
/* module identifier */

const __vue_module_identifier__$d = undefined;
/* functional template */

const __vue_is_functional_template__$d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, undefined, undefined, undefined);

var script$c = {
  name: "VcForm",
  methods: {
    validate() {
      this.form.componentInstance.validate();
    }

  },
  render: function (createElement) {
    // `<v-form><slot></slot></v-form>`
    const props = {
      attrs: this.$attrs,
      on: this.$listeners
    };
    this.form = createElement('v-form', props, this.$slots.default);
    return this.form;
  }
};

/* script */
const __vue_script__$c = script$c;
/* template */

/* style */

const __vue_inject_styles__$c = undefined;
/* scoped */

const __vue_scope_id__$c = "data-v-398cf17d";
/* module identifier */

const __vue_module_identifier__$c = undefined;
/* functional template */

const __vue_is_functional_template__$c = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, undefined, undefined, undefined);

var script$b = {
  name: "VcInputModal",
  components: {
    VcForm: __vue_component__$c,
    VcLayout: __vue_component__$g,
    VcModalFooter: __vue_component__$f,
    VcIcon: __vue_component__$j,
    VcModalContainer: __vue_component__$h,
    VcModalHeader: __vue_component__$e
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    topTitle: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    headerIcon: {
      type: String,
      required: false
    },
    headerImage: {
      type: String,
      required: false
    },
    size: {
      type: String,
      default: 'lg',
      // required
      validator: prop => ['md', 'lg'].includes(prop)
    }
  },
  data: () => ({
    mainValid: true,
    additionalValid: true
  }),
  methods: {
    onOkClicked() {
      this.validate();
      this.$emit('onOkClicked', {
        valid: this.mainValid && this.additionalValid
      });
    },

    validate() {
      this.$refs.mainForm.validate();
      this.$refs.additionalForm && this.$refs.additionalForm.validate();
    },

    onMainFormValueChanged(value) {
      this.mainValid = value;
      this.$emit('onValidationChanged', {
        valid: this.mainValid && this.additionalValid
      });
    },

    onAdditionalFormValueChanged(value) {
      this.additionalValid = value;
      this.$emit('onValidationChanged', {
        valid: this.mainValid && this.additionalValid
      });
    }

  }
};

/* script */
const __vue_script__$b = script$b;
/* template */

var __vue_render__$b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcModalContainer', {
    attrs: {
      "showHeaderDivider": "",
      "showCloseButton": "",
      "flavor": "input",
      "showDialog": _vm.showDialog,
      "size": _vm.$vuetify.breakpoint.mdAndUp ? _vm.size : 'responsive'
    },
    on: {
      "onCloseButtonClicked": function ($event) {
        return _vm.$emit('onCloseButtonClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_vm._t("header", function () {
          return [_c('VcModalHeader', {
            attrs: {
              "topTitle": _vm.topTitle,
              "title": _vm.title,
              "subtitle": _vm.subtitle,
              "icon": _vm.headerIcon,
              "image": _vm.headerImage,
              "flavor": "input"
            },
            on: {
              "onCloseButtonClicked": function ($event) {
                return _vm.$emit('onCloseButtonClicked');
              }
            }
          })];
        })];
      },
      proxy: true
    }, {
      key: "content",
      fn: function () {
        return [_c('VcLayout', {
          staticClass: "VcInputForm-layout"
        }, [_c('VcForm', {
          ref: "mainForm",
          staticClass: "VcInputForm-main",
          attrs: {
            "value": _vm.mainValid,
            "lazy-validation": ""
          },
          on: {
            "input": _vm.onMainFormValueChanged
          }
        }, [_vm._t("content")], 2), _vm._v(" "), _vm.$slots.additional && _vm.size === 'lg' && _vm.$vuetify.breakpoint.mdAndUp ? _c('VcForm', {
          ref: "additionalForm",
          staticClass: "VcInputForm-additional",
          attrs: {
            "value": _vm.additionalValid,
            "lazy-validation": ""
          },
          on: {
            "input": _vm.onAdditionalFormValueChanged
          }
        }, [_vm._t("additional")], 2) : _vm._e()], 1)];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function () {
        return [_vm._t("footer", function () {
          return [_c('VcModalFooter', {
            attrs: {
              "direction": "horizontal",
              "buttons": [{
                label: "cancel",
                event: "onCancelClicked",
                color: "white"
              }, {
                label: "ok",
                event: "onOkClicked",
                color: "secondary"
              }]
            },
            on: {
              "onOkClicked": _vm.onOkClicked,
              "onCancelClicked": function ($event) {
                return _vm.$emit('onCancelClicked');
              }
            }
          })];
        })];
      },
      proxy: true
    }], null, true)
  });
};

var __vue_staticRenderFns__$b = [];
/* style */

const __vue_inject_styles__$b = function (inject) {
  if (!inject) return;
  inject("data-v-01f920b6_0", {
    source: ".VcInputForm-layout .VcInputForm-main[data-v-01f920b6]{width:100%;max-width:100%;padding:var(--size-value6)}.VcInputForm-layout .VcInputForm-additional[data-v-01f920b6]{min-width:324px;padding:var(--size-value6);background:#f8f9fb;border-left:1px solid rgba(0,0,0,.12)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$b = "data-v-01f920b6";
/* module identifier */

const __vue_module_identifier__$b = undefined;
/* functional template */

const __vue_is_functional_template__$b = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, createInjector, undefined, undefined);

var script$a = {
  name: "VcNoticeModal",
  components: {
    VcLayout: __vue_component__$g,
    VcModalFooter: __vue_component__$f,
    VcModalContainer: __vue_component__$h
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    titleText: {
      type: String,
      required: true
    },
    subtitleText: {
      type: String,
      required: true
    },
    contentText: {
      type: String,
      required: false
    },
    size: {
      type: String,
      default: 'lg',
      // required
      validator: prop => ['md', 'lg', 'sm'].includes(prop)
    },
    flavor: {
      type: String,
      default: 'notice',
      validator: prop => ['notice', 'prominent'].includes(prop)
    }
  }
};

/* script */
const __vue_script__$a = script$a;
/* template */

var __vue_render__$a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcModalContainer', {
    attrs: {
      "showFooterDivider": _vm.flavor === 'prominent',
      "flavor": _vm.flavor,
      "showDialog": _vm.showDialog,
      "size": _vm.$vuetify.breakpoint.mdAndUp ? _vm.size : 'responsive',
      "showCloseButton": ""
    },
    on: {
      "onCloseButtonClicked": function ($event) {
        return _vm.$emit('onCloseButtonClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function () {
        return [_c('VcLayout', {
          class: "VcNoticeHeader " + _vm.flavor,
          attrs: {
            "column": "",
            "align-content-center": ""
          }
        }, [_c('img', {
          staticClass: "VcNoticeImage",
          class: "" + _vm.size,
          attrs: {
            "src": _vm.icon
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "VcNoticeHeaderText"
        }, [_vm._v(_vm._s(_vm.titleText))])]), _vm._v(" "), _c('VcLayout', {
          class: "VcNoticeSubtitle " + _vm.flavor,
          attrs: {
            "column": ""
          }
        }, [_vm._v(_vm._s(_vm.subtitleText))]), _vm._v(" "), _vm._t("content", function () {
          return [_vm.contentText ? _c('VcLayout', {
            class: "VcNoticeContent " + _vm.size,
            attrs: {
              "column": ""
            }
          }, [_vm._v("\n        " + _vm._s(_vm.contentText) + "\n      ")]) : _vm._e()];
        })];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function () {
        return [_vm._t("footer", function () {
          return [_c('VcModalFooter', {
            staticClass: "VcNoticeFooter",
            attrs: {
              "direction": "vertical",
              "buttons": [{
                label: "ok",
                event: "onOkClicked",
                color: "secondary"
              }, {
                label: "cancel",
                event: "onCancelClicked",
                color: "white"
              }]
            },
            on: {
              "onOkClicked": function ($event) {
                return _vm.$emit('onOkClicked');
              },
              "onCancelClicked": function ($event) {
                return _vm.$emit('onCancelClicked');
              }
            }
          })];
        })];
      },
      proxy: true
    }], null, true)
  });
};

var __vue_staticRenderFns__$a = [];
/* style */

const __vue_inject_styles__$a = function (inject) {
  if (!inject) return;
  inject("data-v-67e92f52_0", {
    source: ".VcNoticeImage[data-v-67e92f52]{margin-bottom:var(--size-value4)}.VcNoticeImage.md[data-v-67e92f52],.VcNoticeImage.responsive[data-v-67e92f52],.VcNoticeImage.sm[data-v-67e92f52]{max-height:160px}.VcNoticeImage.lg[data-v-67e92f52]{max-height:208px}.VcNoticeContent[data-v-67e92f52],.VcNoticeHeader[data-v-67e92f52],.VcNoticeSubtitle[data-v-67e92f52]{text-align:center;line-height:24px}.VcNoticeHeader[data-v-67e92f52]{text-align:center;font-size:18px;font-weight:600;line-height:28px}@media screen and (min-width:960px){.VcNoticeHeader[data-v-67e92f52]{font-size:24px;font-weight:800;line-height:var(--size-value10)}}.VcNoticeHeader .VcNoticeHeaderText[data-v-67e92f52]{padding-bottom:var(--size-value2)}.VcNoticeHeader.prominent .VcNoticeHeaderText[data-v-67e92f52]{font-size:18px;font-weight:600}.VcNoticeSubtitle[data-v-67e92f52]{font-size:15px;font-weight:var(--font-weight-medium);line-height:var(--size-value6)}@media screen and (min-width:960px){.VcNoticeSubtitle[data-v-67e92f52]{font-size:var(--font-size-small)}}.VcNoticeSubtitle.prominent[data-v-67e92f52]{font-size:15px}.VcNoticeContent[data-v-67e92f52]{background:#eafcf2;border:1px solid #cff8e1;box-sizing:border-box;border-radius:8px;padding:var(--size-value3) var(--size-value4);margin-top:var(--size-value4);line-height:20px;font-size:13px}@media screen and (min-width:960px){.VcNoticeContent[data-v-67e92f52]{line-height:21px;font-size:14px}}.VcNoticeFooter[data-v-67e92f52]{padding-bottom:var(--size-value10)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$a = "data-v-67e92f52";
/* module identifier */

const __vue_module_identifier__$a = undefined;
/* functional template */

const __vue_is_functional_template__$a = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, createInjector, undefined, undefined);

var script$9 = {
  name: "VcAlert",
  components: {
    VcIcon: __vue_component__$j,
    VcButton: __vue_component__$i,
    VcLayout: __vue_component__$g,
    VAlert: VAlert
  },
  props: {
    type: {
      type: String,
      required: true,
      validator: prop => ['attention', 'warning', 'info', 'success'].includes(prop)
    },
    headerText: {
      type: String
    },
    bodyText: {
      type: String
    },
    buttonText: {
      type: String
    },
    isStripe: {
      type: Boolean,
      default: false
    },
    closeButton: {
      type: Boolean,
      default: false
    },
    isInlineHeader: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'vc-alert'
    }
  },
  computed: {
    getStripe() {
      return this.isStripe ? 'stripe' : '';
    },

    getClass() {
      return `vcita-alert-${this.type} ${this.getStripe}`;
    },

    getIcon() {
      switch (this.type) {
        case 'warning':
          return '$warning';

        case 'info':
          return '$info';

        case 'success':
          return '$check_circle';

        default:
          return '$error';
      }
    },

    getBodyText() {
      if (this.isInlineHeader && this.headerText) {
        return `<span class="alert-header">${this.headerText}</span> ${this.bodyText}`;
      }

      return this.bodyText;
    }

  }
};

/* script */
const __vue_script__$9 = script$9;
/* template */

var __vue_render__$9 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VAlert', {
    staticClass: "dialog-alert",
    class: _vm.getClass,
    attrs: {
      "data-qa": _vm.dataQa,
      "icon": _vm.getIcon
    }
  }, [_c('VcLayout', {
    staticClass: "alert-content",
    attrs: {
      "align-start": "",
      "column": "",
      "classes": {
        'dialog-alert__close-btn': _vm.closeButton
      }
    }
  }, [[_vm.headerText && !_vm.isInlineHeader ? _c('span', {
    staticClass: "alert-header"
  }, [_vm._v("\n        " + _vm._s(_vm.headerText) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm.bodyText ? _c('span', {
    staticClass: "alert-body",
    domProps: {
      "innerHTML": _vm._s(_vm.getBodyText)
    }
  }) : _vm._e()]], 2), _vm._v(" "), _vm.buttonText ? _c('VcButton', {
    staticClass: "action-button",
    attrs: {
      "plain": "",
      "data-qa": "alert-action-btn"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onAction');
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('VcIcon', [_vm._v("$arrow_right")])];
      },
      proxy: true
    }], null, false, 3701565208)
  }, [_vm._v("\n    " + _vm._s(_vm.buttonText) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.closeButton ? _c('VcButton', {
    staticClass: "close-button",
    attrs: {
      "data-qa": "alert-close-btn",
      "fab": "",
      "plain": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('closeAlert');
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('VcIcon', [_vm._v("$close_button")])];
      },
      proxy: true
    }], null, false, 521807287)
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__$9 = [];
/* style */

const __vue_inject_styles__$9 = function (inject) {
  if (!inject) return;
  inject("data-v-8fcbab0a_0", {
    source: ".dialog-alert{padding:12px}.dialog-alert__close-btn{margin-inline-end:28px}.dialog-alert .alert-content{padding-inline-end:36px}.dialog-alert .close-button{position:absolute;width:24px;height:24px;top:12px;right:12px}#app[dir=rtl] .dialog-alert .close-button{right:auto;left:12px}.dialog-alert .close-button .v-btn__content{opacity:unset}.dialog-alert .close-button:hover{background-color:rgba(0,0,0,.07)}.dialog-alert .close-button .v-icon{margin-right:0}.dialog-alert .close-button .v-icon svg{fill:#999}.dialog-alert.stripe.v-alert{border-radius:0;border-top:none;border-left:none;border-right:none}.dialog-alert.vcita-alert-attention{border:1px solid #fbcbc9;background-color:#fde8e7}.dialog-alert.vcita-alert-attention .v-icon{margin-right:12px;align-items:baseline}.dialog-alert.vcita-alert-attention .v-icon svg.vc-notif{fill:#f2514a}.dialog-alert.vcita-alert-warning{border:1px solid #ffedb8;background-color:#fff7e0}.dialog-alert.vcita-alert-warning .v-alert__wrapper .v-icon{margin-right:12px;align-items:baseline}.dialog-alert.vcita-alert-warning .v-alert__wrapper .v-icon svg.vc-notif{fill:#ffc511}.dialog-alert.vcita-alert-info{border:1px solid #c8ddff;background-color:#e7f0ff}.dialog-alert.vcita-alert-info .v-alert__wrapper .v-icon{margin-right:12px;align-items:baseline}.dialog-alert.vcita-alert-info .v-alert__wrapper .v-icon svg.vc-notif{fill:#478fff}.dialog-alert.vcita-alert-success{border:1px solid #cff8e1;background-color:#eafcf2}.dialog-alert.vcita-alert-success .v-icon{margin-right:12px;align-items:baseline}.dialog-alert.vcita-alert-success .v-icon svg.vc-notif{fill:#54d28c}.dialog-alert .v-alert__wrapper .v-icon__component{height:20px;width:20px}.dialog-alert .v-alert__wrapper .v-icon__component svg.vc-notif{font-size:20px;height:20px;min-width:20px}.dialog-alert .v-alert__wrapper .v-icon__component svg.arrow-right{fill:#478fff}.dialog-alert .alert-header{font-weight:700;font-size:13px;line-height:20px;letter-spacing:.003em;margin-bottom:4px;color:#212121}.dialog-alert .alert-header:after{content:\" \";padding-right:4px}.dialog-alert .alert-body{font-size:13px;line-height:20px;letter-spacing:-.01em;color:#212121}.dialog-alert .alert-body a{color:-webkit-link}.dialog-alert .VcButton .v-icon{margin-right:initial;align-items:initial}.dialog-alert .VcButton.action-button{height:24px;color:#478fff!important;font-weight:600;font-size:13px;line-height:24px;margin-top:4px;padding:0}.dialog-alert .VcButton.action-button span.v-btn__content{opacity:unset!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$9 = undefined;
/* module identifier */

const __vue_module_identifier__$9 = undefined;
/* functional template */

const __vue_is_functional_template__$9 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$8 = {
  components: {
    VCol: VCol,
    VRow: VRow,
    VContainer: VContainer
  },

  name: "VcButtonGroup",

  props: {
    buttons: {
      type: Array,
      required: true,
      validator: function (buttons) {
        return buttons.length >= 4 && buttons.length <= 9 && buttons.every(button => !!button.id && !!button.label);
      }
    },
    selected: String,
    direction: {
      type: String,
      default: 'vertical',
      validator: prop => ['horizontal', 'vertical'].includes(prop)
    },
    dataQa: {
      type: String,
      default: 'VcButtonGroup'
    }
  },

  model: {
    prop: 'selected',
    event: 'change'
  },

  created() {
    this.buttonSelected = this.selected;
  },

  data() {
    return {
      buttonSelected: false
    };
  },

  computed: {
    rows() {
      let rows = [];
      let numOfRows = Math.ceil(this.buttons.length / this.cols);

      for (let row = 0; row < numOfRows; row++) {
        const sliceStart = row * this.cols;
        const sliceEnd = row * this.cols + this.cols;
        const buttonsRow = this.buttons.slice(sliceStart, sliceEnd);
        rows.push(buttonsRow);
      }

      return rows;
    },

    cols() {
      switch (this.buttons.length) {
        case 5:
        case 6:
          return this.direction === 'horizontal' ? 3 : 2;

        case 7:
        case 8:
          return this.direction === 'horizontal' ? 4 : 2;

        case 9:
          return 3;
      }

      return 2;
    }

  },

  methods: {
    onSelected: function (id) {
      this.$emit('change', id);
    }
  }
};

/* script */
const __vue_script__$8 = script$8;
/* template */

var __vue_render__$8 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-container', {
    staticClass: "VcButtonGroup",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, _vm._l(_vm.rows, function (row, rowIdx) {
    return _c('v-row', {
      key: "row-" + rowIdx,
      attrs: {
        "data-qa": "row"
      }
    }, _vm._l(row, function (button, itemIdx) {
      return _c('v-col', {
        key: button.id,
        staticClass: "button-item d-flex align-center justify-center",
        class: {
          'selected': button.id === _vm.selected,
          'top': rowIdx === 0,
          'left': itemIdx === 0,
          'bottom': rowIdx === _vm.rows.length - 1,
          'right': itemIdx === row.length - 1,
          'disabled': button.disabled
        },
        attrs: {
          "cols": Math.floor(12 / _vm.cols),
          "data-qa": "item-" + _vm.buttons.indexOf(button)
        },
        on: {
          "click": function ($event) {
            return _vm.onSelected(button.id);
          }
        }
      }, [_c('div', {
        staticClass: "button-label"
      }, [_vm._v("\n        " + _vm._s(button.label) + "\n      ")])]);
    }), 1);
  }), 1);
};

var __vue_staticRenderFns__$8 = [];
/* style */

const __vue_inject_styles__$8 = function (inject) {
  if (!inject) return;
  inject("data-v-086ba7ac_0", {
    source: ".VcButtonGroup[data-v-086ba7ac]{font-weight:var(--font-weight-medium2);font-size:13px}.VcButtonGroup .button-item[data-v-086ba7ac]{cursor:pointer;transition:.3s background-color,color ease-out;min-height:40px;border-color:#d6dbe6;border-style:solid;border-width:0;color:rgba(0,0,0,.62);border-right-width:1px;border-bottom-width:1px;padding:0 12px}.VcButtonGroup .button-item .button-label[data-v-086ba7ac]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.VcButtonGroup .button-item.left[data-v-086ba7ac]{border-left-width:1px}.VcButtonGroup .button-item.top[data-v-086ba7ac]{border-top-width:1px}.VcButtonGroup .button-item.bottom[data-v-086ba7ac]:not(.top):not(.selected){border-top-width:0}.VcButtonGroup .button-item.top.left[data-v-086ba7ac]{border-top-left-radius:6px}.VcButtonGroup .button-item.top.right[data-v-086ba7ac]{border-top-right-radius:6px}.VcButtonGroup .button-item.bottom.left[data-v-086ba7ac]{border-bottom-left-radius:6px}.VcButtonGroup .button-item.bottom.right[data-v-086ba7ac]{border-bottom-right-radius:6px}.VcButtonGroup .button-item[data-v-086ba7ac]:hover{background-color:rgba(0,0,0,.03)}.VcButtonGroup .button-item[data-v-086ba7ac]:focus{box-shadow:0 0 0 3px var(--v-secondary-lighten1)}.VcButtonGroup .button-item.selected[data-v-086ba7ac]{border:2px solid var(--v-secondary-base);font-weight:600}.VcButtonGroup .button-item.selected[data-v-086ba7ac]:hover{background:rgba(0,0,0,.03)}.VcButtonGroup .button-item[data-v-086ba7ac]:active{background:rgba(0,0,0,.12)}.VcButtonGroup .button-item.disabled[data-v-086ba7ac]{background:rgba(0,0,0,.07);color:rgba(0,0,0,.4);pointer-events:none}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$8 = "data-v-086ba7ac";
/* module identifier */

const __vue_module_identifier__$8 = undefined;
/* functional template */

const __vue_is_functional_template__$8 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
var script$7 = {
  components: {
    VProgressCircular: VProgressCircular
  },

  name: "VcLoader",

  props: {
    value: {
      type: Number,
      default: 40
    },
    color: {
      type: String,
      default: "primary"
    },
    size: {
      type: Number,
      required: false
    },
    width: {
      type: Number,
      required: false
    }
  }
};

/* script */
const __vue_script__$7 = script$7;
/* template */

var __vue_render__$7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-progress-circular', {
    attrs: {
      "value": _vm.value,
      "color": _vm.color,
      "size": _vm.size,
      "width": _vm.width,
      "indeterminate": ""
    }
  });
};

var __vue_staticRenderFns__$7 = [];
/* style */

const __vue_inject_styles__$7 = undefined;
/* scoped */

const __vue_scope_id__$7 = undefined;
/* module identifier */

const __vue_module_identifier__$7 = undefined;
/* functional template */

const __vue_is_functional_template__$7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$6 = {
  components: {
    VSwitch: VSwitch
  },

  name: "VcSwitch",

  props: {
    value: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      required: false
    },
    color: {
      type: String,
      default: 'primary'
    },
    ripple: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};

/* script */
const __vue_script__$6 = script$6;
/* template */

var __vue_render__$6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-switch', {
    staticClass: "VcSwitch",
    class: {
      'is-active': _vm.value
    },
    attrs: {
      "inset": "",
      "hide-details": "",
      "label": _vm.label,
      "ripple": _vm.ripple,
      "input-value": _vm.value,
      "color": _vm.color,
      "disabled": _vm.disabled
    },
    on: {
      "change": function (val) {
        return _vm.$emit('input', Boolean(val));
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_vm._t("label")];
      },
      proxy: true
    }], null, true)
  });
};

var __vue_staticRenderFns__$6 = [];
/* style */

const __vue_inject_styles__$6 = function (inject) {
  if (!inject) return;
  inject("data-v-eb6ebd34_0", {
    source: ".VcSwitch[data-v-eb6ebd34]{padding:0;margin:0}.VcSwitch[data-v-eb6ebd34]  label{font-size:var(--font-size-small);font-weight:var(--font-weight-medium);line-height:var(--size-value6);color:rgba(0,0,0,.87)}.VcSwitch[data-v-eb6ebd34]  input{height:var(--size-value5)}.VcSwitch[data-v-eb6ebd34]  .v-input--selection-controls__input{margin-left:0;margin-right:var(--size-value3);height:var(--size-value5);width:var(--size-value8)}#app[dir=rtl] .VcSwitch[data-v-eb6ebd34]  .v-input--selection-controls__input{margin-left:var(--size-value3)}#app[dir=rtl] .VcSwitch[data-v-eb6ebd34]  .v-input--selection-controls__input{margin-right:0}.VcSwitch[data-v-eb6ebd34]  .v-input--switch__track{top:0;left:0}#app[dir=rtl] .VcSwitch[data-v-eb6ebd34]  .v-input--switch__track{left:auto;right:0}.VcSwitch[data-v-eb6ebd34]  .v-input--selection-controls__ripple{left:-10px;height:25px;width:25px}#app[dir=rtl] .VcSwitch[data-v-eb6ebd34]  .v-input--selection-controls__ripple{left:auto;right:-10px}.VcSwitch[data-v-eb6ebd34]  .v-input--switch__thumb{height:14px;width:14px;background-color:#fff;top:calc(50% - 7px);transform:translateX(3px)!important;box-shadow:0 1px 1px rgba(0,0,0,.141176),0 1px 3px rgba(0,0,0,.2)}#app[dir=rtl] .VcSwitch[data-v-eb6ebd34]  .v-input--switch__thumb{transform:translateX(-3px)!important}.VcSwitch.is-active[data-v-eb6ebd34]  .v-input--switch__track{opacity:1;background-color:currentColor}.VcSwitch.is-active[data-v-eb6ebd34]  .v-input--selection-controls__ripple{transform:translateX(14px)!important}#app[dir=rtl] .VcSwitch.is-active[data-v-eb6ebd34]  .v-input--selection-controls__ripple{transform:translateX(-14px)!important}.VcSwitch.is-active[data-v-eb6ebd34]  .v-input--switch__thumb{transform:translateX(17px)!important}#app[dir=rtl] .VcSwitch.is-active[data-v-eb6ebd34]  .v-input--switch__thumb{transform:translateX(-17px)!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$6 = "data-v-eb6ebd34";
/* module identifier */

const __vue_module_identifier__$6 = undefined;
/* functional template */

const __vue_is_functional_template__$6 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, createInjector, undefined, undefined);

var script$5 = {
  name: 'VcTextField',
  components: {
    VcLayout: __vue_component__$g,
    VcButton: __vue_component__$i,
    VcIcon: __vue_component__$j,
    VTextField: VTextField
  },
  props: {
    type: {
      type: String,
      default: 'text',
      validator: prop => ['text', 'number'].includes(prop)
    },
    label: {
      type: String,
      default: ''
    },
    step: {
      type: String,
      default: '1'
    },
    value: {
      type: [Number, String],
      default: ''
    },
    min: {
      type: Number,
      default: -Infinity
    },
    max: {
      type: Number,
      default: Infinity
    },
    rules: {
      type: Array
    },
    color: {
      type: String,
      default: 'Primary'
    }
  },
  methods: {
    updateValue(num) {
      let currVal = parseFloat(this.value);
      currVal = parseFloat((currVal + num).toPrecision(this.step.length + 1));

      if (currVal < parseFloat(this.min) || currVal > parseFloat(this.max)) {
        return;
      }

      this.$emit('input', currVal.toString());
    }

  }
};

/* script */
const __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-text-field', {
    staticClass: "VcTextInput",
    attrs: {
      "dense": "",
      "label": _vm.label,
      "rules": _vm.rules,
      "type": _vm.type,
      "value": _vm.value,
      "color": _vm.color,
      "step": _vm.step,
      "hide-details": "auto"
    },
    on: {
      "input": function (data) {
        return _vm.$emit('input', data);
      }
    },
    scopedSlots: _vm._u([_vm.type === 'number' ? {
      key: "append",
      fn: function () {
        return [_c('VcLayout', {
          staticClass: "number-counter",
          attrs: {
            "column": ""
          }
        }, [_c('VcButton', {
          attrs: {
            "icon": "",
            "data-qa": "VcTextFieldButtonUp",
            "ripple": false,
            "min-width": "44px",
            "max-height": "25px"
          },
          on: {
            "click": function ($event) {
              _vm.updateValue(parseFloat(_vm.step));
            }
          }
        }, [_c('VcIcon', [_vm._v("icon-caret-down fa-rotate-180")])], 1), _vm._v(" "), _c('VcButton', {
          attrs: {
            "icon": "",
            "data-qa": "VcTextFieldButtonDown",
            "ripple": false,
            "min-width": "44px",
            "max-height": "25px"
          },
          on: {
            "click": function ($event) {
              _vm.updateValue(-parseFloat(_vm.step));
            }
          }
        }, [_c('VcIcon', [_vm._v("icon-caret-down")])], 1)], 1)];
      },
      proxy: true
    } : null], null, true)
  }, [_vm._v(" "), _vm._t("default")], 2);
};

var __vue_staticRenderFns__$5 = [];
/* style */

const __vue_inject_styles__$5 = function (inject) {
  if (!inject) return;
  inject("data-v-31ca7c6a_0", {
    source: ".number-counter[data-v-31ca7c6a]{border-left:1px solid rgba(0,0,0,.12)}#app[dir=rtl] .number-counter[data-v-31ca7c6a]{border-left:none;border-right:1px solid rgba(0,0,0,.12)}",
    map: undefined,
    media: undefined
  }), inject("data-v-31ca7c6a_1", {
    source: ".VcTextInput.v-text-field{margin:0;padding:0}.VcTextInput.v-text-field label{letter-spacing:-.3px;font-size:15px;color:rgba(0,0,0,.4)}.VcTextInput.v-text-field .v-text-field__slot:first-child{margin:0 12px}.VcTextInput.v-text-field[prepend-inner-icon] .v-text-field__slot{padding:0}.VcTextInput.v-text-field.v-input--is-focused label,.VcTextInput.v-text-field.v-input--is-label-active label{font-size:14px;font-weight:400;font-stretch:normal;font-style:normal;line-height:1.17;letter-spacing:-.3px;color:rgba(0,0,0,.62)!important;transform:translateY(-100%) scale(.85);top:8px}.VcTextInput.v-text-field:not(.v-text-field--outlined) .v-text-field__slot{transition:margin-bottom .1s}.VcTextInput.v-text-field:not(.v-text-field--outlined).v-input--is-focused .v-text-field__slot,.VcTextInput.v-text-field:not(.v-text-field--outlined).v-input--is-label-active .v-text-field__slot{margin-bottom:-20px}.VcTextInput.v-text-field.v-input--is-focused .v-input__slot{border-color:currentColor}.VcTextInput.v-text-field .v-input__slot{min-height:52px!important;border-radius:6px;background-color:#fff!important;position:relative!important;border:solid 1px rgba(0,0,0,.12);transition:border-color,background-color .1s!important}.VcTextInput.v-text-field .v-input__slot:hover{border-color:currentColor}.VcTextInput.v-text-field .v-input__slot:after,.VcTextInput.v-text-field .v-input__slot:before{display:none}.VcTextInput.v-text-field.v-input--is-disabled .v-input__slot{background-color:rgba(0,0,0,.03)!important}.VcTextInput.v-text-field input{font-size:15px!important;font-weight:500}.VcTextInput.v-text-field .v-text-field__prefix{color:rgba(0,0,0,.54)!important}.VcTextInput.v-text-field .v-input__append-inner,.VcTextInput.v-text-field .v-input__prepend-inner{color:rgba(0,0,0,.4);margin:auto 12px auto 12px!important;max-width:20px;max-height:20px;padding:0!important}.VcTextInput.v-text-field .v-input__append-inner .v-input__icon,.VcTextInput.v-text-field .v-input__prepend-inner .v-input__icon{height:100%;max-width:100%;min-width:100%;max-height:100%;min-height:100%}.VcTextInput.v-text-field .v-input__append-inner i,.VcTextInput.v-text-field .v-input__prepend-inner i{color:rgba(0,0,0,.4)}.VcTextInput.v-text-field.error--text .v-input__slot{border:1px solid #f2514a}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$5 = "data-v-31ca7c6a";
/* module identifier */

const __vue_module_identifier__$5 = undefined;
/* functional template */

const __vue_is_functional_template__$5 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$4 = {
  components: {
    VIcon: VIcon,
    VTooltip: VTooltip
  },

  data() {
    return {
      icons: {
        flag: {
          backgroundColor: '#478FFF',
          size: '10',
          icon: '$flag'
        },
        customer: {
          backgroundColor: '#54D28C',
          size: '10',
          icon: '$customer'
        },
        inactive: {
          backgroundColor: '#586E8C',
          size: '10',
          icon: '$inactive'
        },
        vip: {
          backgroundColor: '#FF9718',
          size: '10',
          icon: '$vip'
        },
        confirmed: {
          backgroundColor: '#54D28C',
          size: '8',
          icon: '$success'
        }
      }
    };
  },

  name: "VcAvatar",

  props: {
    imagePath: {
      type: String
    },
    name: {
      type: String
    },
    text: {
      type: String
    },
    colorId: {
      type: Number
    },
    size: {
      type: String,
      default: 'md'
    },
    badgeIcon: {
      type: String,
      default: ''
    },
    badgePosition: {
      type: String,
      default: 'right'
    },
    lightMode: {
      type: Boolean,
      default: false
    },
    lightModeTooltip: {
      type: String,
      default: ''
    }
  },

  computed: {
    computedClasses() {
      return this.colorClass + " " + this.size + " " + (this.lightMode && !this.imagePath ? "light-mode" : "");
    },

    computedBadgeClass() {
      return this.badgeIcon + " " + this.size + " " + this.badgePosition;
    },

    colorClass() {
      return !this.imagePath && this.colorId ? `color-${this.colorId}` : '';
    },

    initials() {
      return this.getInitials(this.name);
    }

  },

  methods: {
    getInitials(name) {
      let split = name.trim().split(' ').filter(Boolean);
      let initials = '';

      if (split.length) {
        initials += split[0][0];

        if (split[1]) {
          initials += split[1][0];
        } else if (split[0][1]) {
          initials += split[0][1];
        }
      }

      return initials.toUpperCase();
    }

  }
};

/* script */
const __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "avatar-wrapper",
    class: _vm.computedClasses
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var on = ref.on;
        ref.attrs;
        return [_vm.imagePath ? _c('img', _vm._g({
          staticClass: "avatar-image",
          attrs: {
            "data-qa": "avatarImage",
            "src": _vm.imagePath
          }
        }, _vm.lightMode && _vm.lightModeTooltip && on)) : !_vm.imagePath && _vm.name || _vm.text ? _c('div', _vm._g({
          staticClass: "avatar-initials",
          attrs: {
            "data-qa": "avatar-initials"
          }
        }, _vm.lightMode && _vm.lightModeTooltip && on), [_vm._v("\n        " + _vm._s(_vm.text || _vm.initials) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm.badgeIcon && _vm.icons[_vm.badgeIcon] ? _c('div', {
          staticClass: "badge d-flex justify-center align-center",
          class: _vm.computedBadgeClass,
          style: {
            backgroundColor: _vm.icons[_vm.badgeIcon].backgroundColor
          }
        }, [_c('v-icon', {
          attrs: {
            "data-qa": "avatarBadgeIcon",
            "size": _vm.icons[_vm.badgeIcon].size
          }
        }, [_vm._v(_vm._s(_vm.icons[_vm.badgeIcon].icon))])], 1) : _vm._e()];
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lightModeTooltip))])])], 1);
};

var __vue_staticRenderFns__$4 = [];
/* style */

const __vue_inject_styles__$4 = function (inject) {
  if (!inject) return;
  inject("data-v-3f493474_0", {
    source: ".avatar-wrapper[data-v-3f493474]{position:relative;border-radius:50%;background-color:#a7a9ac;text-align:center;border:1px solid #fff;color:#fff}.avatar-wrapper.light-mode[data-v-3f493474]{border:1px solid rgba(0,0,0,.3);color:rgba(0,0,0,.3);background-color:#fff}.avatar-wrapper.x-sm[data-v-3f493474]{height:var(--avatar-x-sm);width:var(--avatar-x-sm);font-size:9px}.avatar-wrapper.sm[data-v-3f493474]{height:var(--avatar-sm);width:var(--avatar-sm);font-size:12px}.avatar-wrapper.md[data-v-3f493474]{height:var(--avatar-md);width:var(--avatar-md);font-size:14px}.avatar-wrapper.lg[data-v-3f493474]{height:var(--avatar-lg);width:var(--avatar-lg);font-size:17px}.avatar-wrapper .avatar-image[data-v-3f493474]{display:block;margin:auto;height:100%;width:100%;object-fit:cover;border-radius:50%}.avatar-wrapper .avatar-initials[data-v-3f493474]{position:relative;top:50%;font-weight:var(--font-weight-medium2);transform:translateY(-50%)}.avatar-wrapper .badge[data-v-3f493474]{fill:#fff;position:absolute;--gap:0;height:16px;width:16px;border-radius:50%;bottom:calc(var(--gap) * -1);left:calc(var(--gap) * -1)}.avatar-wrapper .badge.x-sm[data-v-3f493474]{--gap:4px}.avatar-wrapper .badge.sm[data-v-3f493474]{--gap:4px}.avatar-wrapper .badge.md[data-v-3f493474]{--gap:2px}.avatar-wrapper .badge.lg[data-v-3f493474]{--gap:0px}.avatar-wrapper .badge.right[data-v-3f493474]{left:unset;right:calc(var(--gap) * -1)}.avatar-wrapper .badge.confirmed[data-v-3f493474]{border:2px #fff solid}.color-0[data-v-3f493474]{background-color:#fed62f}.color-1[data-v-3f493474]{background-color:#fec22e}.color-2[data-v-3f493474]{background-color:#feac2a}.color-3[data-v-3f493474]{background-color:#fe9a28}.color-4[data-v-3f493474]{background-color:#fd7024}.color-5[data-v-3f493474]{background-color:#fd5b32}.color-6[data-v-3f493474]{background-color:#f2483f}.color-7[data-v-3f493474]{background-color:#dc331b}.color-8[data-v-3f493474]{background-color:#d41419}.color-9[data-v-3f493474]{background-color:#e72866}.color-10[data-v-3f493474]{background-color:#c41c63}.color-11[data-v-3f493474]{background-color:#9b2bae}.color-12[data-v-3f493474]{background-color:#673bb5}.color-13[data-v-3f493474]{background-color:#7c4efc}.color-14[data-v-3f493474]{background-color:#4051b3}.color-15[data-v-3f493474]{background-color:#311b92}.color-16[data-v-3f493474]{background-color:#2d62fb}.color-17[data-v-3f493474]{background-color:#5c6bc0}.color-18[data-v-3f493474]{background-color:#17a8f1}.color-19[data-v-3f493474]{background-color:#17bbd2}.color-20[data-v-3f493474]{background-color:#14abbf}.color-21[data-v-3f493474]{background-color:#0f9587}.color-22[data-v-3f493474]{background-color:#16bea5}.color-23[data-v-3f493474]{background-color:#4eae53}.color-24[data-v-3f493474]{background-color:#3a8d3f}.color-25[data-v-3f493474]{background-color:#8cc250}.color-26[data-v-3f493474]{background-color:#66bb6a}.color-27[data-v-3f493474]{background-color:#880e4f}.color-28[data-v-3f493474]{background-color:#1565c0}.color-29[data-v-3f493474]{background-color:#1e88e5}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$4 = "data-v-3f493474";
/* module identifier */

const __vue_module_identifier__$4 = undefined;
/* functional template */

const __vue_is_functional_template__$4 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$3 = {
  components: {
    VTextarea: VTextarea
  },

  name: 'VcTextArea',

  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    rules: {
      type: Array
    },
    dataQa: {
      type: String,
      default: 'vc-text-area'
    },
    counter: {
      type: [Number, String],
      default: 25
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    messages: {
      type: [String, Boolean],
      default: ''
    }
  }
};

/* script */
const __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-textarea', {
    staticClass: "VcTextArea",
    attrs: {
      "dense": "",
      "primary": "",
      "messages": _vm.messages,
      "label": _vm.label,
      "rules": _vm.rules,
      "value": _vm.value,
      "placeholder": _vm.placeholder,
      "hide-details": "auto",
      "disabled": _vm.disabled,
      "counter": _vm.counter,
      "data-qa": _vm.dataQa
    },
    on: {
      "input": function (data) {
        return _vm.$emit('input', data);
      }
    }
  });
};

var __vue_staticRenderFns__$3 = [];
/* style */

const __vue_inject_styles__$3 = function (inject) {
  if (!inject) return;
  inject("data-v-35c01692_0", {
    source: "[data-v-35c01692].VcTextArea.v-text-field .v-text-field__slot:first-child{margin-inline-start:12px;margin-top:3px}[data-v-35c01692].VcTextArea.v-text-field.v-input--is-focused label,[data-v-35c01692].VcTextArea.v-text-field.v-input--is-label-active label{font-size:12px;color:rgba(0,0,0,.62)!important;transform:translateY(-18px) scale(.85)}[data-v-35c01692].VcTextArea.v-text-field:not(.v-text-field--outlined) .v-text-field__slot{transition:margin-bottom .1s}[data-v-35c01692].VcTextArea.v-text-field:not(.v-text-field--outlined).v-input--is-focused .v-text-field__slot,[data-v-35c01692].VcTextArea.v-text-field:not(.v-text-field--outlined).v-input--is-label-active .v-text-field__slot{margin-bottom:0}[data-v-35c01692].VcTextArea.v-text-field:not(.v-text-field--outlined).v-input--is-focused .v-input__slot,[data-v-35c01692].VcTextArea.v-text-field:not(.v-text-field--outlined).v-input--is-label-active .v-input__slot{padding-top:20px}[data-v-35c01692].VcTextArea.v-text-field .v-input__slot{border-radius:6px;background-color:#fff!important;position:relative!important;border:solid 1px rgba(0,0,0,.12);transition:border-color .1s!important}[data-v-35c01692].VcTextArea.v-text-field .v-input__slot:hover{border-color:var(--v-secondary-base);box-shadow:0 0 0 3px var(--v-secondary-lighten1);transition:box-shadow .1s!important}[data-v-35c01692].VcTextArea.v-text-field .v-input__slot:after,[data-v-35c01692].VcTextArea.v-text-field .v-input__slot:before{display:none}[data-v-35c01692].VcTextArea.v-text-field textarea{font-size:15px!important;font-weight:500;margin-top:0;line-height:1.5}[data-v-35c01692].VcTextArea.v-text-field .v-text-field__prefix{color:rgba(0,0,0,.54)!important}[data-v-35c01692].VcTextArea.v-text-field.error--text .v-input__slot{border:1px solid var(--v-danger-base);box-shadow:none}[data-v-35c01692].VcTextArea.v-text-field.v-input--is-disabled .v-input__slot{background-color:rgba(0,0,0,.03)!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$3 = "data-v-35c01692";
/* module identifier */

const __vue_module_identifier__$3 = undefined;
/* functional template */

const __vue_is_functional_template__$3 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, createInjector, undefined, undefined);

//
//
//
//
var script$2 = {
  name: 'VcSvg',
  props: ['svg']
};

/* script */
const __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.svg)
    }
  });
};

var __vue_staticRenderFns__$2 = [];
/* style */

const __vue_inject_styles__$2 = undefined;
/* scoped */

const __vue_scope_id__$2 = undefined;
/* module identifier */

const __vue_module_identifier__$2 = undefined;
/* functional template */

const __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

var script$1 = {
  name: 'VcToast',
  components: {
    VcAlert: __vue_component__$9,
    VSnackbar: VSnackbar
  },
  props: {
    value: {
      type: Boolean
    },
    timeout: {
      type: Number,
      required: false
    }
  },
  computed: {
    computedTimeout() {
      return this.timeout || this.$ds.toastTimeout || 3000;
    }

  }
};

/* script */
const __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-snackbar', {
    attrs: {
      "value": _vm.value || false,
      "color": _vm.color || _vm.type,
      "timeout": _vm.computedTimeout,
      "bottom": "",
      "left": !_vm.$vuetify.rtl,
      "right": _vm.$vuetify.rtl
    }
  }, [_c('VcAlert', _vm._b({
    attrs: {
      "is-stripe": false
    }
  }, 'VcAlert', _vm.$attrs, false))], 1);
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$1 = function (inject) {
  if (!inject) return;
  inject("data-v-2dfe68ea_0", {
    source: "[data-v-2dfe68ea] .v-snack__action{display:none}[data-v-2dfe68ea] .v-alert{margin-bottom:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1 = "data-v-2dfe68ea";
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
var script = {
  components: {
    VCard: VCard
  },

  name: "VcCard",

  props: {
    dataQa: {
      type: String,
      default: 'VcCard'
    }
  }
};

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-card', {
    staticClass: "VcCard",
    attrs: {
      "tile": "",
      "data-qa": _vm.dataQa
    }
  }, [_vm._t("default", function () {
    return [_vm._v("\n  " + _vm._s(this.$slots && this.$slots.default) + "\n  ")];
  })], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-45292040_0", {
    source: ".VcCard[data-v-45292040]{position:relative;padding:16px 0 0;border-bottom:1px solid #e0e0e0;background:#fff;box-sizing:border-box;box-shadow:none!important}@media screen and (min-width:960px){.VcCard[data-v-45292040]{display:flex;flex-direction:column;align-items:flex-start;padding:24px;border:1px solid #e0e0e0;border-radius:6px!important}.VcCard[data-v-45292040]:hover{box-shadow:0 4px 18px rgba(145,152,160,.22)!important}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = "data-v-45292040";
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

// Put here any components that need to be available to users of the package

var components$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  VcConfirmModal: __vue_component__$d,
  VcInputModal: __vue_component__$b,
  VcNoticeModal: __vue_component__$a,
  VcModalFooter: __vue_component__$f,
  VcModalHeader: __vue_component__$e,
  VcAlert: __vue_component__$9,
  VcButton: __vue_component__$i,
  VcButtonGroup: __vue_component__$8,
  VcForm: __vue_component__$c,
  VcIcon: __vue_component__$j,
  VcLayout: __vue_component__$g,
  VcLoader: __vue_component__$7,
  VcSwitch: __vue_component__$6,
  VcTextField: __vue_component__$5,
  VcAvatar: __vue_component__$4,
  VcTextArea: __vue_component__$3,
  VcSvg: __vue_component__$2,
  VcToast: __vue_component__$1,
  VcCard: __vue_component__
});

// Import vue components

const install = function installdesignSystem(Vue, props) {
  Object.entries(components$1).forEach(([componentName, component]) => {
    Vue.component(componentName, component);
  });
}; // Create module definition for Vue.use()

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': install,
  VcConfirmModal: __vue_component__$d,
  VcInputModal: __vue_component__$b,
  VcNoticeModal: __vue_component__$a,
  VcModalFooter: __vue_component__$f,
  VcModalHeader: __vue_component__$e,
  VcAlert: __vue_component__$9,
  VcButton: __vue_component__$i,
  VcButtonGroup: __vue_component__$8,
  VcForm: __vue_component__$c,
  VcIcon: __vue_component__$j,
  VcLayout: __vue_component__$g,
  VcLoader: __vue_component__$7,
  VcSwitch: __vue_component__$6,
  VcTextField: __vue_component__$5,
  VcAvatar: __vue_component__$4,
  VcTextArea: __vue_component__$3,
  VcSvg: __vue_component__$2,
  VcToast: __vue_component__$1,
  VcCard: __vue_component__
});

// iife/cjs usage extends esm default export - so import it all
// only expose one global var, with component exports exposed as properties of
// that global var (eg. plugin.component)

Object.entries(components).forEach(([componentName, component]) => {
  if (componentName !== 'default') {
    install[componentName] = component;
  }
});

export default install;
